import {DataSubcategorySelectItem} from './data-subcategory-select-item';

export const DATA_SUBCATEGORY_SELECT_DATA: DataSubcategorySelectItem[] = [
  {
    id: 'Accidents',
    dataCategoryId: 'Traffic Information',
    label: 'Accidents',
  },

  {
    id: 'Hazard Warnings',
    dataCategoryId: 'Traffic Information',
    label: 'Hazard Warnings',
  },

  {
    id: 'Roadworks',
    dataCategoryId: 'Roadworks and Road Conditions',
    label: 'Roadworks',
  },

  {
    id: 'Road Conditions',
    dataCategoryId: 'Roadworks and Road Conditions',
    label: 'Road Conditions',
  },

  {
    id: 'Realtime Traffic Flow Data',
    dataCategoryId: 'Traffic Flow Information',
    label: 'Realtime Traffic Flow Data',
  },

  {
    id: 'Forecast Traffic Flow Data',
    dataCategoryId: 'Traffic Flow Information',
    label: 'Forecast Traffic Flow Data',
  },

  {
    id: 'Availability and Forecast',
    dataCategoryId: 'Parking Information',
    label: 'Availability and Forecast',
  },

  {
    id: 'Prices',
    dataCategoryId: 'Parking Information',
    label: 'Prices',
  },

  {
    id: 'Location of Charging Station',
    dataCategoryId: 'Electromobility',
    label: 'Location of Charging Station',
  },

  {
    id: 'Prices at Charging Station',
    dataCategoryId: 'Electromobility',
    label: 'Prices at Charging Station',
  },

  {
    id: 'Availability of Charging Station',
    dataCategoryId: 'Electromobility',
    label: 'Availability of Charging Station',
  },

  {
    id: 'Dynamic Speed Information',
    dataCategoryId: 'Traffic Signs and Speed Information',
    label: 'Dynamic Speed Information',
  },

  {
    id: 'Dynamic Traffic Signs',
    dataCategoryId: 'Traffic Signs and Speed Information',
    label: 'Dynamic Traffic Signs',
  },

  {
    id: 'Static Traffic Signs',
    dataCategoryId: 'Traffic Signs and Speed Information',
    label: 'Static Traffic Signs',
  },

  {
    id: 'Current Weather Conditions',
    dataCategoryId: 'Weather Information',
    label: 'Current weather conditions',
  },

  {
    id: 'Weather Forecast ',
    dataCategoryId: 'Weather Information',
    label: 'Weather Forecast ',
  },

  {
    id: 'Special Events or Disruptions',
    dataCategoryId: 'Weather Information',
    label: 'Special Events or Disruptions',
  },

  {
    id: 'Timetables',
    dataCategoryId: 'Public Transport Information',
    label: 'Timetables',
  },

  {
    id: 'Fare',
    dataCategoryId: 'Public Transport Information',
    label: 'Fare',
  },

  {
    id: 'Location Information',
    dataCategoryId: 'Public Transport Information',
    label: 'Location Information',
  },

  {
    id: 'Vehicle Information ',
    dataCategoryId: 'Shared and On-Demand Mobility',
    label: 'Vehicle information',
  },

  {
    id: 'Availability ',
    dataCategoryId: 'Shared and On-Demand Mobility',
    label: 'Availability',
  },

  {
    id: 'Location ',
    dataCategoryId: 'Shared and On-Demand Mobility',
    label: 'Location',
  },

  {
    id: 'Range ',
    dataCategoryId: 'Shared and On-Demand Mobility',
    label: 'Range',
  },

  {
    id: 'General Information About Planning Of Routes',
    dataCategoryId: 'Infrastructure and Logistics',
    label: 'General Information About Planning Of Routes',
  },

  {
    id: 'Pedestrian Networks',
    dataCategoryId: 'Infrastructure and Logistics',
    label: 'Pedestrian Networks',
  },

  {
    id: 'Cycling Networks',
    dataCategoryId: 'Infrastructure and Logistics',
    label: 'Cycling Networks',
  },

  {
    id: 'Road Network',
    dataCategoryId: 'Infrastructure and Logistics',
    label: 'Road Network',
  },

  {
    id: 'Water Routes',
    dataCategoryId: 'Infrastructure and Logistics',
    label: 'Water Routes',
  },

  {
    id: 'Cargo Logistics',
    dataCategoryId: 'Infrastructure and Logistics',
    label: 'Cargo and Logistics',
  },

  {
    id: 'Toll Information',
    dataCategoryId: 'Infrastructure and Logistics',
    label: 'Toll Information',
  },
];
